import { favoriteListQueryKeys as e } from "./favoriteListQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { favoriteListsApi as r } from "@maat/api-main";
//#region src/favoriteLists/useDeleteFavoriteListMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.deleteList(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.feed() });
		}
	});
};
//#endregion
export { i as useDeleteFavoriteListMutation };
